import { Flex } from "@chakra-ui/react"
import { FramerBox } from "@components/animations/FramerBox"
import DashboardImage from "@public/images/why/emenu-dashboard.png"
import { AnimatePresence } from "framer-motion"
import Image from "next/image"

const Dashboard = () => {
  return (
    <AnimatePresence>
      <FramerBox
        key={"dashboard"}
        initial={{ opacity: 0, x: 0, y: 400 }}
        whileInView={{
          opacity: 1,
          x: 0,
          y: 0,
        }}
        exit={{ opacity: 0, x: 0, y: 0, scale: 0 }}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        transition={{
          duration: 0.2,
          ease: "easeInOut",
        }}
      >
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Image
            src={DashboardImage}
            loader={({ src }) => src}
            alt={"Dynamic Dashboard"}
          />
        </Flex>
      </FramerBox>
    </AnimatePresence>
  )
}

export default Dashboard
